import React from "react";

function Experience() {
  return (
    <section id="about" className="tc-experience-style1 section-padding-x">
      <div className="container-fluid">
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-2">
            <div className="exp-num mb-100 wow zoomIn" data-wow-delay="0.3s">
              <h5 className="fsz-18 text-uppercase">
                سنوات من <br /> الخبرة
              </h5>
              <h2 className="num"> 9 </h2>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="img wow">
              <img
                src="/home1/assets/img/exp.webp"
                alt=""
                className="img-cover"
              />
            </div>
          </div>
          <div className="col-lg-3">
            <div className="info wow fadeInUp" data-wow-delay="0.3s">
              <h3 className="fsz-45 fw-600 mb-30"> عن الشركة </h3>
              <div className="text fsz-15 color-666">
                تُعد تعمير للمقاولات والتطوير واحدة من الشركات الرائدة في مصر في
                مجالات البناء والتصميم. نتخصص في تقديم حلول مبتكرة للمشاريع
                الداخلية والخارجية باستخدام أجود المواد وأحدث التقنيات. تجمع
                أعمالنا بين الرقي، العملية، والابتكار، مما يمنح كل مشروع طابعًا
                فريدًا يعكس احتياجات وتطلعات عملائنا.
              </div>
              {/* <a
                href="#"
                className="butn rounded-pill mt-50 hover-bg-black bg-white"
              >
                <span>
                  معرض الاعمال <i className="small ms-1 ti-arrow-top-right"></i>
                </span>
              </a> */}
            </div>
          </div>
          <div className="col-lg-2">
            <div
              className="rotate-txt justify-content-lg-end"
              style={{ transformOrigin: "left" }}
            >
              <ul>
                <li>
                  <a href="mailto:info@tameer-egypt.com">
                    info@tameer-egypt.com
                  </a>
                </li>
                {/* <li>
                  <a href="#"> (054) 3256 78 87 </a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <img
        src="/home1/assets/img/c_line.webp"
        alt=""
        className="c-line end-0 wow"
        style={{ transform: "scaleX(-1)" }}
      />
    </section>
  );
}

export default Experience;
